export default __webpack_public_path__ + "static/media/webilo-software-products.27de517a.svg";